import { CodedError } from '../CodedError';
import { errorCodeTypes } from './errorCodeTypes';

export class UnitExternalReferenceInvalidError extends CodedError {
  static get errorName() {
    return errorCodeTypes.unitExternalReferenceInvalidError.code;
  }

  constructor(
    message = errorCodeTypes.unitExternalReferenceInvalidError.message
  ) {
    super(message);
    this.code = errorCodeTypes.unitExternalReferenceInvalidError.code;
    this.message = `${message} ${errorCodeTypes.unitExternalReferenceInvalidError.code}`;
    this.name = errorCodeTypes.unitExternalReferenceInvalidError.name;
  }
}
